import { render, staticRenderFns } from "./AcuerdosClientesPage.vue?vue&type=template&id=37fd9650"
import script from "./AcuerdosClientesPage.vue?vue&type=script&lang=js"
export * from "./AcuerdosClientesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports